import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "showBreezeIcon"];
import UIIcon from 'UIComponents/icon/UIIcon';
import { getStyledAIButton } from './styledButtons/StyledAIBaseButton';
import { BREEZE_SPECIAL } from '../../../constants/BreezeUse';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AIBaseButton(_ref) {
  let {
      children,
      showBreezeIcon = true
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const useOverride = uiButtonProps.use === BREEZE_SPECIAL ? undefined : uiButtonProps.use;
  const AIButtonComponent = getStyledAIButton(uiButtonProps.use);
  return /*#__PURE__*/_jsxs(AIButtonComponent, Object.assign({}, uiButtonProps, {
    use: useOverride,
    children: [showBreezeIcon && /*#__PURE__*/_jsx(UIIcon, {
      name: "breezeSingleStar",
      className: "ai-icon"
    }), children]
  }));
}